import { css } from '@emotion/react';
import { math } from 'polished';
import { HoverFocus } from './mixins/_hover.mixin';
import { BorderRadius, BorderTopRadius } from './mixins/_border-radius.mixin';


export default ($) => css`
  .nav {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .nav-link {
    display: block;
    padding: ${$.navLinkPaddingY} ${$.navLinkPaddingX};
    text-decoration: ${$.linkDecoration === 'none' ? 'null' : 'none'};

    ${new HoverFocus().include($, css`
      text-decoration: none;
    `)}

    &.disabled {
      color: ${$.navLinkDisabledColor};
      pointer-events: none;
      cursor: default;
    }
  }

  .nav-tabs {
    border-bottom: ${$.navTabsBorderWidth} solid ${$.navTabsBorderColor};

    .nav-link {
      margin-bottom: ${math(`-${$.navTabsBorderWidth}`)};
      border: ${$.navTabsBorderWidth} solid transparent;
      ${new BorderTopRadius($.navTabsBorderRadius).include($)};

      ${new HoverFocus().include($, css`
        border-color: ${$.navTabsLinkHoverBorderColor};
      `)}

      &.disabled {
        color: ${$.navLinkDisabledColor};
        background-color: transparent;
        border-color: transparent;
      }
    }

    .nav-link.active,
    .nav-item.show .nav-link {
      color: ${$.navTabsLinkActiveColor};
      background-color: ${$.navTabsLinkActiveBg};
      border-color: ${$.navTabsLinkActiveBorderColor};
    }

    .dropdown-menu {
      margin-top: ${math(`-${$.navTabsBorderWidth}`)};
      ${new BorderTopRadius(0).include($)};
    }
  }

  .nav-pills {
    .nav-link {
      ${new BorderRadius($.navPillsBorderRadius).include($)};
    }

    .nav-link.active,
    .show > .nav-link {
      color: ${$.navPillsLinkActiveColor};
      background-color: ${$.navPillsLinkActiveBg};
    }
  }

  .nav-fill {
    > .nav-link,
    .nav-item {
      flex: 1 1 auto;
      text-align: center;
    }
  }

  .nav-justified {
    > .nav-link,
    .nav-item {
      flex-basis: 0;
      flex-grow: 1;
      text-align: center;
    }
  }

  .tab-content {
    > .tab-pane {
      display: none;
    }
    > .active {
      display: block;
    }
  }
`;
